import axios from "axios";
import usuarioStore from "./usuario";
import pedidosStore from "./pedidos";
import moment from "moment";
import Vue from "vue";
import {
  getDadosInsumosDB,
  getPedidosDB,
  saveDadosInsumosDB,
  savePedidosDB,
} from "@/db/pedidos";

const getDefaultState = () => {
  return {
    lista_itens: [],
    pedido_item: {
      id: 0,
      cliente: null,
      filial: 0,
      filialSelecionada: null,
      tipo_acerto: "",
      pessoa: "",
      grupo: 0,
      subgrupo: 0,
      item: 0,
      descricao: "",
      cod_forma_pgto: 0,
      safrinha: false,
      cadproSelecionado: null,
      cadpro: "",
      vencimento: "",
      unitario: 0.0,
      quantidade: 0,
      tipo_pedido: 0,
      tipo_cultura: "",
      cod_vendedor: 0,
      usuario: 0,
      unit_lista: 0.0,
      lavoura: "",
      culturaSelecionada: null,
      idcultura: 0,
      safraSelecionada: null,
      idsafra: 0,
      data_pontual: "",
      desconto_pontual: 0.0,
      valor_pontual: 0.0,
      data_seg_pontual: 0.0,
      desconto_seg_pontual: 0.0,
      valor_seg_pontual: 0.0,
      perc_sobras: 0.0,
      valor_sobras: 0.0,
      desconto_antec: 0.0,
      cod_embal_relac: 0,
      embalagemSelecionada: null,
      tipo_tratamento: "",
      tratamentoSelecionado: null,
      observacoes: "",
      observComplementar: "",
      cod_vendedor_externo: 0,
      tem_remessa: false,
      saldo_disponivel: 0
    },
    culturas: [],
    filiais: [],
    dialogProdInsumos: false,
    produtosDisponiveis: [],
    vctoCotado: moment().format("YYYY-MM-DD"),
    observacao: "",
    tratamentoCalcular: null,
    emitindoPedido: false,
    assinatura: "",
    config: null,
    pedidosOffline: [],
    pedidosComSaldo: [],
    produtoSelecionado: null,
    adicionandoProduto: false,
    atualizarDadosInsumos: false,
    id_novo_pedido: 0,
    modo_busca_produtos: "",
    pesquisaProduto: ""
  };
};

const insumosStore = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setPedidoItem(state, value) {
      state.pedido_item = value;
    },
    adicionarItem(state) {
      state.pedido_itens.push(state.item);
    },
    setCulturas(state, value) {
      state.culturas = value;
    },
    setFiliais(state, value) {
      state.filiais = value;
    },
    setDialogProdInsumos(state, value) {
      state.dialogProdInsumos = value;
    },
    setProdutosDisponiveis(state, value) {
      state.produtosDisponiveis = value;
    },
    setPedidoItemStorage(state) {
      if (sessionStorage.getItem("pedido_item") != undefined) {
        Object.assign(state.pedido_item, {
          ...JSON.parse(sessionStorage.getItem("pedido_item")),
        });
      }
    },
    setObservacao(state, value) {
      state.observacao = value;
    },
    setVctoCotado(state, value) {
      state.vctoCotado = value;
    },
    setListaItens(state) {
      state.lista_itens = [];
      if (sessionStorage.getItem("itens_add") != undefined) {
        var itens = JSON.parse(sessionStorage.getItem("itens_add"));
        itens.forEach((element) => {
          state.lista_itens.push(element);
        });
      }
    },
    limparProdutosAdicionados() {
      sessionStorage.removeItem("itens_add");
    },
    setConfig(state, value) {
      state.config = value;
    },
    setPedidosOffline(state, value) {
      state.pedidosOffline = value;
    },
    setPedidosComSaldo(state, value) {
      state.pedidosComSaldo = value;
    },
    setProdutoSelecionado(state, value) {
      state.produtoSelecionado = value;
    },
    async setProdutosDisponiveisStorage(state) {
      const prods = await getDadosInsumosDB();
      if (prods != null && prods[0].produtos.length > 0) {
        state.produtosDisponiveis = prods[0].produtos;
      }
    },
    setAtualizarDadosInsumos(state, value) {
      state.atualizarDadosInsumos = value;
    },
    setModoBuscaProdutos(state, value) {
      state.modo_busca_produtos = value;
    },
    setPesquisaProduto(state, value) {
      state.pesquisaProduto = value
    }
  },
  actions: {
    async getCotacoesOnline(context) {
      await axios
        .post(
          "/detec/produtos-cotacao",
          JSON.stringify(context.state.produtoSelecionado),
          {
            params: {
              token: usuarioStore.state.usuarioLogado.token_detec,
              modo: "cotacoes",
            },
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )
        .then((res) => {
          if (res.status == 200) {
            context.commit("setProdutoSelecionado", res.data);
          }
        });
    },
    async getPedidosComSaldo(context) {
      context.commit("setPedidosComSaldo", []);
      await axios
        .get("/detec/pedidos-completo", {
          params: {
            token: usuarioStore.state.usuarioLogado.token_detec,
          },
        })
        .then((res) => {
          if (res.status == 200) {
            context.commit("setPedidosComSaldo", res.data);
          }
        });
    },
    async getCulturas(context) {
      context.commit("setCulturas", []);

      await axios
        .get("/detec/culturas", {
          params: {
            token: usuarioStore.state.usuarioLogado.token_detec,
          },
        })
        .then((res) => {
          if (res.status == 200) {
            context.commit("setCulturas", res.data);
          }
        });
    },
    async getDadosInsumos(context) {
      context.commit("setFiliais", []);
      context.commit("setProdutosDisponiveis", []);
      context.commit("setConfig", null);
      if (navigator.onLine && context.state.atualizarDadosInsumos) {
        await axios
          .get("/detec/produtos-cotacao", {
            params: {
              token: usuarioStore.state.usuarioLogado.token_detec,
              id_pedido: context.state.id_novo_pedido,
              modo: context.state.modo_busca_produtos,
            },
          })
          .then(async (res) => {
            if (res.status == 200) {

              context.commit("setFiliais", res.data.filiais);
              context.commit("setProdutosDisponiveis", res.data.produtos);
              context.commit("setConfig", res.data.config);
              if (context.state.id_novo_pedido > 0) {
                const dataSalvar = await getDadosInsumosDB();
                if (dataSalvar.length > 0) {
                  for (const p of context.state.produtosDisponiveis) {
                    var pos = dataSalvar[0].produtos.findIndex(
                      (prod) => prod.id == p.id
                    );
                    dataSalvar[0].produtos[pos] = p;
                  }

                  //dataSalvar[0].produtos = res.data.produtos;
                  await saveDadosInsumosDB(dataSalvar[0]);
                }
              }
            }
          });
      } else {
        await context.dispatch("setarDadosInsumosOffline");
      }
    },

    async setarDadosInsumosOffline(context) {
      const dadosInsumos = await getDadosInsumosDB();
      if (dadosInsumos.length > 0) {
        if (!navigator.onLine) {
          context.commit("setCulturas", dadosInsumos[0].culturas);
        }
        context.commit("setFiliais", dadosInsumos[0].filiais);
        context.commit("setProdutosDisponiveis", dadosInsumos[0].produtos);
        context.commit("setConfig", dadosInsumos[0].config);
      }
    },
    adicionarProduto(context) {
      context.state.pedido_item.tem_remessa =
        context.state.produtoSelecionado.tem_remessa;
      context.state.pedido_item.filial =
        context.state.pedido_item.filialSelecionada.filial;
      context.state.tratamentoCalcular =
        context.state.pedido_item.tratamentoSelecionado;
      context.state.pedido_item.unitario = context.getters.getterUnitCotacao;
      context.state.pedido_item.cadpro =
        context.state.pedido_item.cadproSelecionado.nrcadpro;
      context.state.pedido_item.pessoa =
        context.state.pedido_item.cliente.matricula.toString();
      context.state.pedido_item.cod_embal_relac =
        context.state.pedido_item.embalagemSelecionada.codigo;
      context.state.pedido_item.tipo_tratamento =
        context.state.pedido_item.tratamentoSelecionado.tipo;
      context.state.pedido_item.idcultura =
        context.state.pedido_item.culturaSelecionada.codigo;
      context.state.pedido_item.idsafra =
        context.state.pedido_item.safraSelecionada.idsafra;
      context.state.pedido_item.tipo_cultura =
        context.state.pedido_item.culturaSelecionada.descricao;
      context.state.pedido_item.safrinha =
        context.state.pedido_item.culturaSelecionada.safrinha;
      context.state.pedido_item.usuario =
        context.state.pedido_item.filialSelecionada.cod_user;
      context.state.pedido_item.tipo_pedido = 1;
      context.state.pedido_item.cod_vendedor_externo =
        usuarioStore.state.usuarioLogado.codrepresentante;

      var listaJaAdd = [];
      if (sessionStorage.getItem("itens_add") != undefined) {
        listaJaAdd = JSON.parse(sessionStorage.getItem("itens_add"));
      }

      listaJaAdd.push(context.state.pedido_item);
      sessionStorage.setItem("itens_add", JSON.stringify(listaJaAdd));

      //context.state.lista_itens.push(context.state.pedido_item);
      //context.dispatch("atualizarListaItens");
    },
    recalcularProduto(context) {
      context.state.calcularItens = true;
      context.state.lista_itens.forEach((item) => {
        context.state.tratamentoCalcular = item.tratamentoSelecionado;
        item.vencimento = context.state.pedido_item.vencimento;
        item.unitario = context.getters.getterUnitCotacao;
      });
      context.dispatch("atualizarListaItens");
    },
    atualizarListaItens(context) {
      sessionStorage.setItem(
        "itens_add",
        JSON.stringify(context.state.lista_itens)
      );
    },
    async salvarPedido(context) {
      return await axios.post(
        "/detec/salvar-pedido",
        JSON.stringify({ itens: context.state.lista_itens }),
        {
          params: {
            token: usuarioStore.state.usuarioLogado.token_detec,
          },
        }
      );
    },
    async emitirPedido(context) {
      if (
        context.state.config.assinatura_obrigatoria &&
        (pedidosStore.state.novopedido.assinatura == "" ||
          pedidosStore.state.novopedido.assinatura == null)
      ) {
        Vue.toasted.error("Assinatura obrigatória!");
        return;
      }

      context.state.emitindoPedido = true;
      context.state.lista_itens.forEach((item) => {
        item.observacoes = context.state.observacao;
        if (
          pedidosStore.state.novopedido.assinatura != "" &&
          pedidosStore.state.novopedido.assinatura != null
        ) {
          item.assinatura = pedidosStore.state.novopedido.assinatura;
        }
      });

      if (navigator.onLine) {
        const res = await context.dispatch("salvarPedido");
        if (res.status == 200) {
          sessionStorage.clear();
          context.commit("setAtualizarDadosInsumos", true);
          context.state.id_novo_pedido = res.data.pedido;
          await context.dispatch("getDadosInsumos");
          context.state.id_novo_pedido = 0;
          context.commit("setAtualizarDadosInsumos", false);
          context.state.emitindoPedido = false;
          Vue.toasted.success(res.data.msg);

          return {
            success: true,
            data: res.data,
          };
        } else {
          context.state.emitindoPedido = false;
          Vue.toasted.error(res.data.msg);
          return {
            success: false,
            data: null,
          };
        }
      } else {
        await savePedidosDB(
          { itens: context.state.lista_itens },
          "pedidos-insumos"
        );
        context.state.emitindoPedido = false;
        sessionStorage.clear();
        return {
          success: true,
          data: {},
        };
      }
    },
    async getPedidosOffline(context) {
      context.commit("setPedidosOffline", []);
      const pedidosOff = await getPedidosDB("pedidos-insumos");
      pedidosOff.forEach((p) => {
        context.state.pedidosOffline.push(p.itens);
      });
    },
  },
  getters: {
    getterSafras(state) {
      if (state.pedido_item.culturaSelecionada)
        return state.pedido_item.culturaSelecionada.safras;
      return [];
    },
    vlrTotalProdutos(state) {
      var vlrTotal = 0;
      state.lista_itens.forEach((item) => {
        vlrTotal += item.unitario * item.quantidade;
      });
      return vlrTotal;
    },
    getterUnitCotacao(state) {
      const cotacao = state.tratamentoCalcular.cotacoes.find(
        (c) => c.data == state.pedido_item.vencimento
      );

      if (state.pedido_item.cliente.socio) {
        return cotacao.vlr_socio;
      } else {
        return cotacao.vlr_nao_socio;
      }
    },
  },
};

export default insumosStore;
